// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root {\n  /* UiHeading0 */\n  --fontSize_36px: 36px;\n  --lineHeight_40px: 40px;\n}\n", "",{"version":3,"sources":["webpack://./src/browser/css/fonts.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB","sourcesContent":[":root {\n  /* UiHeading0 */\n  --fontSize_36px: 36px;\n  --lineHeight_40px: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
